export const BuiltinBlockIds = {
	DisplayLabels: '$builtin:DisplayLabels',
	FormSeparator: '$builtin:FormSeparator',
	Input: '$builtin:Input',
	InputColor: '$builtin:InputColor',
	InputDecimalNumber: '$builtin:InputDecimalNumber',
	InputIcon: '$builtin:InputIcon',
	InputNumber: '$builtin:InputNumber',
	InputPassword: '$builtin:InputPassword',
	InputRepeater: '$builtin:InputRepeater',
	InputSelect: '$builtin:InputSelect',
	InputSwitch: '$builtin:InputSwitch',
	InputTextarea: '$builtin:InputTextarea',
	InputTextareaFile: '$builtin:InputTextareaFile',
	InputUuid: '$builtin:InputUuid',
	SystemCollectionFieldSelect: '$builtin:SystemCollectionFieldSelect',
} as const;
